import { Validator } from './validator';
import { TaxView } from '../view/tax-view';

export class TaxValidator implements Validator {

    private isResponsePendingCallback: any;
    view: TaxView = new TaxView();
    
    constructor(isResponsePendingCallback: any) {
        this.isResponsePendingCallback = isResponsePendingCallback;
    }

    validate(): Promise<boolean> {
        this.view.hideZipError();
        const isResponsePending = this.isResponsePendingCallback();
        if (isResponsePending) {
            return Promise.resolve(false);
        }
        const countriesElement = this.view.getCountriesElement() as HTMLSelectElement;
        const country = countriesElement.value;
        if (country !== 'US') {
            return Promise.resolve(true);
        }
        const zipElement = this.view.getZipElement() as HTMLInputElement;
        const zip = zipElement.value;
        const isValid = zip && zip.trim().length !== 0 ? true : false;
        if (!isValid) {
            this.view.showZipError();
        }
        return Promise.resolve(isValid);
    }

}
